import React, { Component } from 'react';
import { post } from '../utils/request';
import queryString from 'query-string';
import { wxShare, isWeChat, deleteUrlKey } from '../utils/util';

// component
import Banner from '../components/banner';
import Login from '../components/login';
import Intro from '../components/intro';
import TopDom from '../components/top';
import Dialog from '../components/dialog';
import AttService from '../components/attentionService';
import { UserInfoExpo } from '../components/groupPerson';
import { ProjectInfoExpo } from '../components/groupProject';
import { ExpoComNeedsInfo } from '../components/groupOther';

class Class extends Component {
  constructor (props) {
    super(props)
    // 报名表信息
    this.state = {
      checkErr: false, // 检测表单数据
      hasLogin: false, //默认没登录的情况下不会出现表单
      currentPageInfo: {}, // 页面基础信息
      endGetUserInfo: false, // 页面表单信息获取完毕
      endGetPage: false, //页面基本信息获取完毕
      userInfo: {}, // 用户基本信息和项目信息
      showServiceDialog: false, // 展示服务号关注二维码
      wechatDialogJson: {}, // 传微信参数
      commitFlag: true
    }
    
    // login组件信息
    this.loginInfo = {
      urlValues: '',
      userInfo: {}
    };
  }
  componentDidMount () {
    const urlValues = queryString.parse(this.props.location.search);
    this.pageUrlValues = urlValues;
    this.loginInfo.urlValues = urlValues; // 传值给login组件
    this.getPageInfo();
  }
  getPageInfo = () => {
    post('/fancube/apply/apply_info/', {
      "code": this.pageUrlValues.acid
    })
    .then(res => {
      if (res.code === 200) {
        // set title
        if (res.data.apply_title) {
          document.title = res.data.apply_title
        }
        wxShare('欢迎企业定制小饭桌游学课堂，简单填写信息表，剩下的小饭桌创业课堂来办！','根据您的需求为您安排更合适的课堂');
        // storage
        localStorage.removeItem('formPageSto');
        localStorage.setItem('formPageSto', JSON.stringify({
          banner: res.data.top_pc_banner,
          from: 'expocustom',
          title: res.data.apply_title,
          shareUrl: deleteUrlKey('code')
        }))
        // change state
        this.setState({
          currentPageInfo: res.data,
          isCourseOut: new Date(res.data.date) < new Date(),
          endGetPage: 'end'
        })
      }
    })
  }
  getUserInfo = (phone) => {
    post('/fancube/apply/v2/expo/en/', {
      "code": this.pageUrlValues.acid,
      "phone": phone
    })
    .then(res => {
      if (res.code === 200) {
        if (res.data.apply === null) {
          res.data.apply = {
            companion_count: 1,
            country: "",
            hope_travel_time: "",
            theme: ""
          }
        }
        this.setState({
          userInfo: res.data,
          endGetUserInfo: 'end'
        })
      }
    })
  }
  getUserData = (resPonUserData) => {
    this.setState({
      resPonUserData
    })
  }
  getProjectData = (resProjectData) => {
    this.setState({
      resProjectData
    })
  }
  getApplyData = (resApplyData) => {
    this.setState({
      resApplyData
    })
  }
  getAttService = (resAttService) => {
    this.setState({
      subscribe: resAttService.subscribe
    })
  }
  getLoginData = (resLoginData) => {
    this.resLoginData = resLoginData;
    this.setState({
      hasLogin: resLoginData.hasLogin,
      openId: resLoginData.openid
    },() => {
      if (this.state.hasLogin) {
        // 登录成功后获取页面个人信息
        this.getUserInfo(resLoginData.userLoginInfo.phone);
        // 传参给服务号二维码组件
        let wechatDialogJson = {
          'code': this.pageUrlValues.acid
        }
        if (isWeChat() && this.state.openId ) {
          wechatDialogJson['openid'] = this.state.openId;
        }
        this.setState({
          wechatDialogJson: wechatDialogJson
        })
      }
    })
  }
  ajaxSubmitData = () => {
    this.state.resApplyData['code'] = this.pageUrlValues.acid;
    this.state.resApplyData['channel'] = this.pageUrlValues.channel;

    this.state.resProjectData.company_name = this.state.resPonUserData.company_name;

    if (this.state.resPonUserData.isRight && this.state.resProjectData.isRight && this.state.resApplyData.isRight && this.state.commitFlag) {
      this.setState({
        commitFlag: false
      })
      let vendorVal = sessionStorage.getItem('UserVendor') && sessionStorage.getItem('UserVendor') !== null && sessionStorage.getItem('UserVendor') !== 'null' ? sessionStorage.getItem('UserVendor') : '';
      post('/fancube/apply/v2/expo/submit/', {
        "project": this.state.resProjectData,
        "entrepreneur": this.state.resPonUserData,
        "apply": this.state.resApplyData,
        "uid": this.resLoginData.userLoginInfo.uid,
        "vendor": vendorVal
      }).then(res => {
        this.setState({
          commitFlag: true
        })
        if (res.code === 200) {
          // 没有关注服务号的情况
          if (!!!this.state.subscribe) {
            this.setState({
              showServiceDialog: true
            })
          }
          // 已经关注服务号
          else {
            const { history } = this.props;
            const location = {
              pathname: '/success'
            }
            history.push(location);
          }
        }
      })
    }
  }
  handleSubmit = (event) => {
    this.setState({
      checkErr: true
    })
    event.preventDefault();
    this.ajaxSubmitData();
  }
  render () {
    let [changeJson, applyJson] = [{}, {}];
    if (this.state.endGetUserInfo) {
      if (this.state.userInfo.project && this.state.userInfo.project.company_name) {
        changeJson = { 
          "company_name": this.state.userInfo.project.company_name
        };
      }
    }
    return (
      <div className="class-wrapper page-wrapper">
        { 
          this.state.endGetPage &&
          <div className="end-wrapper">
          <TopDom />
          <Banner url={this.state.currentPageInfo.top_pc_banner}/>
          <Intro {...this.state.currentPageInfo} isShowValue={this.pageUrlValues} showFeeIntro={true} />
          <Login {...this.loginInfo} type={this.state.currentPageInfo.type} receiveData={this.getLoginData} />
          {
            this.state.hasLogin && this.state.endGetUserInfo &&
            <div className="form-info-wrapper">
              <div className="form-title">填写报名信息</div>
              <ExpoComNeedsInfo { ...this.state.userInfo.apply } checkErr={ this.state.checkErr } receiveData={ this.getApplyData } />
              <UserInfoExpo { ...this.state.userInfo.entrepreneur } {...changeJson} checkErr={ this.state.checkErr } receiveData={ this.getUserData } />
              <ProjectInfoExpo { ... this.state.userInfo.project } isCustom={true} {...applyJson} checkErr={ this.state.checkErr } receiveData={ this.getProjectData } />
              <Dialog isShow={ this.state.showServiceDialog }>
                <AttService receiveData={ this.getAttService } { ...this.state.wechatDialogJson } isShowDia={ this.state.showServiceDialog } history={ this.props.history }/>
              </Dialog>
              { this.state.checkErr && (!this.state.resPonUserData.isRight || !this.state.resProjectData.isRight || !this.state.resApplyData.isRight) && <p className="err-bottom-tips">请完善相关资料</p>}
              <div className={this.state.commitFlag ? "submit-form l-button" : "submit-form l-button disabled"} onClick={ this.handleSubmit }>{this.state.commitFlag ? '立即报名' : '正在提交...'}</div>
            </div>
          }
          </div>
        }
      </div>
    )
  }
}
export default Class;